import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import { ItManagementSoftwareSetupContractItemFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteSoftwareSetupContract } from 'modules/it_management/hooks/useDeleteSoftwareSetupContract'

interface Props {
  contract: ItManagementSoftwareSetupContractItemFragment
  softwareSetupId: number
}

const ContractActions = ({ contract, softwareSetupId }: Props) => {
  const [isOpen, toggleOpen] = useToggle(false)

  const { deleteSoftwareSetupContract, loading: deleting } = useDeleteSoftwareSetupContract()

  const onSubmit = async () => {
    const response = await deleteSoftwareSetupContract({
      softwareSetupId: softwareSetupId,
    })
    const result = handleResult(response, () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      toggleOpen(false)
    }
  }

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>

        <PopoverMenu.Content side="bottom" align="end">
          <PopoverMenu.HrefOption
            download
            target="_blank"
            href={contract.url!}
            title={i18n.t('documents.download')}
          />
          <PopoverMenu.TouchableOption
            onClick={toggleOpen(true)}
            title={i18n.t('documents.delete')}
            danger
          />
        </PopoverMenu.Content>
      </PopoverMenu>

      {isOpen && (
        <Modal
          title={i18n.t('documents.confirm_delete.title')}
          description={i18n.t('documents.confirm_delete.description')}
          illustration="input-field"
          onClose={toggleOpen(false)}
          footer={
            <Button type="negative" onClick={onSubmit} disabled={deleting}>
              {i18n.t('documents.delete')}
            </Button>
          }
        />
      )}
    </>
  )
}

export default ContractActions
